export default {
  meta: {
    title: '行业地图配置',
  },
};
